const BuyNow = ({ ...props }) => {
    return (
        <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 0.274717L1.45917 0L1.95297 1.57142H12.9965C14.3791 1.57142 15.5 2.64151 15.5 3.96153V10.1758H3.61127L0.5 0.274717ZM8.49024 8.26374V6.35165H6.48742V5.3956H8.49024V3.48352H9.49164V5.3956H11.4945V6.35165H9.49164V8.26374H8.49024Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.48461 12.5659C4.48461 11.7739 5.15712 11.1319 5.98672 11.1319C6.81631 11.1319 7.48883 11.7739 7.48883 12.5659C7.48883 13.3579 6.81631 14 5.98672 14C5.15712 14 4.48461 13.3579 4.48461 12.5659ZM5.98672 12.0879C5.71019 12.0879 5.48601 12.3019 5.48601 12.5659C5.48601 12.8299 5.71019 13.044 5.98672 13.044C6.26325 13.044 6.48742 12.8299 6.48742 12.5659C6.48742 12.3019 6.26325 12.0879 5.98672 12.0879Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4945 12.5659C11.4945 11.7739 12.167 11.1319 12.9966 11.1319C13.8262 11.1319 14.4987 11.7739 14.4987 12.5659C14.4987 13.3579 13.8262 14 12.9966 14C12.167 14 11.4945 13.3579 11.4945 12.5659ZM12.9966 12.0879C12.72 12.0879 12.4959 12.3019 12.4959 12.5659C12.4959 12.8299 12.72 13.044 12.9966 13.044C13.2731 13.044 13.4973 12.8299 13.4973 12.5659C13.4973 12.3019 13.2731 12.0879 12.9966 12.0879Z"
                fill="white"
            />
        </svg>
    )
}

export default BuyNow
